import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { AngularFirestore } from '@angular/fire/firestore';
import { AngularFireUploadTask, AngularFireStorage } from '@angular/fire/storage';
import { AddCardComponent } from '../stripe/add-card/add-card.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { NotifierService } from 'angular-notifier';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, from, Subscription, Subject } from 'rxjs';
import { tap, finalize, switchMap, takeUntil } from 'rxjs/operators';
import * as firebase from 'firebase';
import { CardListingComponent } from '../card-listing/card-listing.component';
import { AuthService } from '@app/core/auth/auth.service';
import { ProfileService } from '@app/core/auth/profile.service';
import { PaymentSourceService } from '@app/core/services/payment-source.service';
import { TermsOfAgreementComponent } from '@app/shared/components/terms-of-agreement/terms-of-agreement.component';
import { User } from '@app/models/user.model';
import { DateUtil } from '@app/shared/utils/date-util.service';
import { ConfigService } from '../../../../infrastructure/core/services/config.service';
import { Months } from '../../../../models/calendar.model';

@Component({
  selector: 'app-profile',
  templateUrl: './profile-info.component.html',
  styleUrls: ['./profile-info.component.scss']
})
export class ProfileInfoComponent implements OnInit, OnDestroy {
  task: AngularFireUploadTask;
  snapshot: Observable<any>;
  downloadURL: Observable<string>;
  percentage: Observable<number>;
  haveCard: boolean;
  haveStripeAccount: boolean;
  processLoading = false;
  isModalLoading = false;
  public isHovered = true;
  private readonly notifier: NotifierService;
  public user: User;
  public test: any;
  public days: any;
  phoneCodes = ['+65', '+63'];
  birthYears = [];
  isPhoneDirty = false;
  public profileOriginalValues = {
    displayName: null,
    firstName: null,
    lastName: null,
    email: ''
  };
  public profileOriginalValuesChecker = {
    displayName: false,
    firstName: false,
    lastName: false,
    mobile: false,
    phoneCode: false
  };
  formValues: FormGroup = this.fb.group({
    firstName: ['', [Validators.required]],
    lastName: ['', [Validators.required]],
    displayName: [null],
    email: ['', [Validators.required, Validators.email]],
    phoneCode: [null, []],
    mobile: [null, []],
    address: [null, []],
    aboutMe: [],
    gender: [null, []],
    birthDay: this.fb.group({
      day: ['', []],
      month: ['', []],
      year: ['', []],
    })
  });
  originalPhone = '';
  verificationCode = '';
  disableVerificationCode = false;

  mobileFormValidation: FormGroup;

  profileListener: Subscription;

  listOfMonths: Months[];

  @ViewChild('verifyPhoneTmpl') verifyPhoneTmpl: any;
  @ViewChild('profileUpdateTmpl') profileUpdateTmpl: any;

  public profileChanged = false;
  unsubscribe$ = new Subject();


  get ifProfileChanged(): boolean {
    let val = true;
    Object.keys(this.profileOriginalValuesChecker).forEach(item => {
      if (this.profileOriginalValuesChecker[item]) {
        val = false;
      }
    });
    return val;
  }
  constructor(
    private authService: AuthService,
    private router: Router,
    public ngbModal: NgbModal,
    private notifierService: NotifierService,
    private profileService: ProfileService,
    private storage: AngularFireStorage,
    private afs: AngularFirestore,
    private paySrcSvc: PaymentSourceService,
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private dateUtil: DateUtil,
    private configService: ConfigService
  ) {
    this.notifier = notifierService;
    this.birthYears = this.dateUtil.generateArrayOfYears();
    const queryParam = this.activatedRoute.snapshot.queryParams;
    if (queryParam.checkStripe) {

    }
    this.days = Array.from(Array(31)).map((x, i) => i);
  }

  get ifNotRoot(): boolean {
    return this.router.url.includes('/profile/');
  }

  get isVerifiedUser() {
    if (this.user) {
      return this.user.emailVerified && this.user.mobileVerified;
    }
    return false;
  }

  ngOnInit() {
    this.processLoading = true;
    // control for existence of stripe account login data
    this.haveStripeAccount = !!localStorage.getItem('stripeAccFlg');
    this.profileListener = this.authService.user
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((user: User) => {
        if (user) {
          if (user.firstName) {
            this.formValues.controls.firstName.patchValue(user.firstName);
            this.profileOriginalValues.firstName = user.firstName;
          }
          if (user.lastName) {
            this.formValues.controls.lastName.patchValue(user.lastName);
            this.profileOriginalValues.lastName = user.lastName;
          }
          if (user.displayName) {
            this.formValues.controls.displayName.patchValue(user.displayName);
            this.profileOriginalValues.displayName = user.displayName;
          }
          if (user.mobile) {
            this.originalPhone = user.mobile;
            const phoneCodeIdx = this.phoneCodes.findIndex(d => (user.mobile as string).includes(d));
            if (phoneCodeIdx !== -1) {
              this.formValues.get('phoneCode').setValue(this.phoneCodes[phoneCodeIdx]);
              const mobileData = (user.mobile as string).replace(this.phoneCodes[phoneCodeIdx], '');
              this.formValues.get('mobile').setValue(mobileData);
            }
          }
          if (user.birthDay) {
            this.formValues.get('birthDay').get('day').patchValue(user.birthDay.day);
            this.formValues.get('birthDay').get('month').patchValue(user.birthDay.month);
            this.formValues.get('birthDay').get('year').patchValue(user.birthDay.year);
          }

          this.formValues.get('email').patchValue(user.email);
          this.formValues.get('email').disable();

          this.formValues.get('address').patchValue(user.address);
          this.formValues.get('aboutMe').patchValue(user.aboutMe);
          this.formValues.get('gender').patchValue(user.gender);
          // this.formValues.displayName = this.user.displayName;
          // this.formValues.firstName = this.user.firstName;
          // this.formValues.lastName = this.user.lastName;

          // control for existence of stripe account based on db data
          this.haveStripeAccount = !!user.stripe_account_ID;

          const authUser = firebase.auth().currentUser;
          this.user = user;
          this.user.creationTime = new Date(authUser.metadata.creationTime);
          this.user.emailVerified = authUser.emailVerified;
          this.cdr.detectChanges();

          // controls the flag wether user has a card registered or not
          this.paySrcSvc.getCards(JSON.parse(localStorage.getItem('user')).uid).subscribe(data => {
            this.processLoading = false;
          }, () => {
            this.processLoading = false;
          });

          this.formValues.updateValueAndValidity();
        } else {
          this.processLoading = false;
        }

      }, (err) => {
        this.processLoading = false;
      });

    this.configService.getMonths()
      .subscribe((months: Months[]) => {
        this.listOfMonths = months;
      });
  }


  async sendVerificationEmail() {
    this.processLoading = true;
    this.authService.sendVerificationMail()
      .then(() => {
        this.notifier.notify('success', 'Your email verification request was success, please check your mailbox');
        this.processLoading = false;
      }, () => {
        this.processLoading = false;
        this.notifier.notify(
          'error', 'There is an error while attempting your request');
      });
  }

  uploadFile(file, uid) {
    const path = `profile-pic/${uid}/${Date.now()}_${file.name}`;
    const ref = this.storage.ref(path);
    this.task = this.storage.upload(path, file);
    from(this.task)
      .pipe(
        switchMap(() => ref.getDownloadURL()),
        tap(url => {
          this.profileService.updateUserProfilePic(url, uid);
        }),
        finalize(() => { })
      )
      .subscribe(
        () => {
          this.notifier.notify('success', 'You have successfully changed your profile pic');
        },
        error => {
          this.notifier.notify(
            'error',
            'There is an error in uploading your profile picture, please try later'
          );
        }
      );
  }

  checkForProfileUpdates(type) {
    if (
      this.formValues.controls[type].value.toLowerCase() !==
      this.profileOriginalValues[type].toLowerCase()
    ) {
      this.profileOriginalValuesChecker[type] = true;
    } else {
      this.profileOriginalValuesChecker[type] = false;
    }
  }

  updateProfile(form) {
    const obj = {};
    Object.keys(this.profileOriginalValuesChecker).forEach(item => {
      if (this.profileOriginalValuesChecker[item]) {
        obj[item] = form.controls[item].value;
      }
    });
    const values = this.formValues.value;
    this.user.firstName = values.firstName || '';
    this.user.lastName = values.lastName || '';
    this.user.displayName = values.displayName || '';
    if (values.phoneCode && values.mobile) {
      this.user.mobile = values.phoneCode + values.mobile;
    }
    if (this.originalPhone !== this.user.mobile) {
      this.user.mobileVerified = false;
    }
    this.user.address = values.address || '';
    this.user.aboutMe = values.aboutMe || '';
    this.user.gender = values.gender || null;

    if (values.birthDay) {
      this.user.birthDay = values.birthDay;
    }

    this.processLoading = true;
    this.profileService.updatedProfile(this.user, this.user.uid).then(res => {
      this.ngbModal.dismissAll();
      this.profileOriginalValuesChecker = {
        displayName: false,
        firstName: false,
        lastName: false,
        mobile: false,
        phoneCode: false
      };

      this.processLoading = false;
      this.notifier.notify('success', 'Successfully updated profile');
    });
  }

  uploadProfilePic(files) {
    if (files && files[0]) {
      if (!files[0].type.includes('image')) {
        this.notifier.notify('error', 'Invalid file please upload .jpg, .png');
        return;
      }
      this.uploadFile(files[0], this.user.uid);
    }
  }
  // saveChanges(form) {
  //   if (this.formValues[form] !== this.user[form]) {
  //     this.profileService.updatedProfile(form, this.formValues[form], this.user.uid).then(res => {
  //       console.log('res', res);
  //     });
  //   }
  // }

  addCard() {
    const result = this.ngbModal.open(AddCardComponent, {
      centered: true,
      size: 'sm'
    }).result;
    // result.then((data) => {
    //   this.ngbModal.dismissAll();
    //   return;
    // }).catch((error) => {
    //   return;
    // });
  }

  viewCard() {
    this.ngbModal.open(CardListingComponent);
  }

  createStripeAccount() {
    const stripeAccountModal = this.ngbModal.open(TermsOfAgreementComponent, { backdrop: 'static' });
    stripeAccountModal.componentInstance.email = this.user.email;

    stripeAccountModal.componentInstance.result.subscribe(result => {
      this.ngbModal.dismissAll();
      this.router.navigate(['profile/stripe-account-info']);
    });
  }

  onToPayout() {
    // if stripe account already exist redirect directly to page
    if (!this.haveStripeAccount) {
      // show Terms of Agreement when user doesnt have stripe account
      const stripeAccountModal = this.ngbModal.open(TermsOfAgreementComponent);
      stripeAccountModal.componentInstance.email = this.user.email;

      stripeAccountModal.componentInstance.result.subscribe(result => {
        this.ngbModal.dismissAll();
        this.router.navigate(['profile/stripe-account-info']);
      });
    }
  }

  testredirect() {
    this.router.navigate(['profile/pay-in-out-method']);
  }

  sendPhoneVerification() {
    this.processLoading = true;
    this.mobileFormValidation = null;
    this.profileService.sendPhoneVerification()
      .subscribe((res) => {
        this.processLoading = false;
        this.cdr.detectChanges();
        document.body.click();
        setTimeout(() => {
          this.ngbModal.open(this.verifyPhoneTmpl, { backdrop: 'static' });
          document.body.click();
          this.cdr.detectChanges();
          setTimeout(() => {
            this.setupMobileVerificationForm();
            document.body.click();
          }, 100);
        }, 200);
      }, (err) => {
        console.log(err.message);
        if (err.message.includes('attempts')) {
          this.notifierService.show({
            message: 'Max attempts to verify your phone is already reached, please try again tomorrow',
            type: 'error'
          });
          document.body.click();
        }
        this.processLoading = false;
      })
  }

  verifyPhone() {
    if (this.mobileFormValidation.valid) {
      this.verificationCode = this.mobileFormValidation.value.code;
      this.isModalLoading = true;
      this.disableVerificationCode = true;
      this.profileService.verifyPhone(this.verificationCode)
        .subscribe((res) => {
          this.ngbModal.dismissAll();
          setTimeout(() => {
            document.body.click();
          }, 300);
        }, (err) => {
          this.isModalLoading = false;
          this.disableVerificationCode = false;
        });
    }
  }

  getPhone() {
    const values = this.formValues.value;

    if (values.phoneCode && values.mobile) {
      return values.phoneCode + values.mobile;
    }

    return '';
  }

  setupMobileVerificationForm() {
    this.mobileFormValidation = this.fb.group({
      code: new FormControl(null, [Validators.required, Validators.maxLength(6), Validators.minLength(6)])
    });
  }

  editAccount() {
    this.ngbModal.open(this.profileUpdateTmpl, { backdrop: 'static', size: 'lg' });
  }

  ngOnDestroy(): void {
    if (this.profileListener) {
      this.profileListener.unsubscribe();
    }
    this.unsubscribe$.next(true);
    this.unsubscribe$.complete();
  }
}
